import React from 'react'
import { ConfigProvider } from 'antd'

interface IProps {}

const IntlWrapper: React.FC<IProps> = ({ children }) => {
    return (
        <ConfigProvider>
            <>{children}</>
        </ConfigProvider>
    )
}

export default IntlWrapper
